import { configureStore } from "@reduxjs/toolkit";
import bizEditReducer from "./bizEditSlice";
import galleryReducer from "./gallerySlice";
import registerReducer from "./registerSlice";
import resetPasswordReducer from "./resetPasswordSlice";

export const store = configureStore({
  reducer: {
    bizEdit: bizEditReducer,
    gallery: galleryReducer,
    register: registerReducer,
    resetPassword: resetPasswordReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["bizEdit.baseline"],
      },
    }),
});
